export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    SMS_CALL_RECORD_ALL: function SMS_CALL_RECORD_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/sms-call-record/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    SMS_CALL_RECORD_CREATE: function SMS_CALL_RECORD_CREATE(data) {
      return request({
        url: '/api/sms-call-record/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SMS_CALL_RECORD_DETAIL: function SMS_CALL_RECORD_DETAIL(id) {
      return request({
        url: '/api/sms-call-record/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SMS_CALL_RECORD_UPDATE: function SMS_CALL_RECORD_UPDATE(data) {
      return request({
        url: '/api/sms-call-record/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    SMS_CALL_RECORD_DELETE: function SMS_CALL_RECORD_DELETE(id) {
      return request({
        url: '/api/sms-call-record/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});